import {
  useAsyncState,
  AsyncStateHookOptions,
  AsyncFunction,
} from 'hooks/useAsyncState';

// DEPRICATED
export const useServiceState = <TParams = void, TData = void>(
  service: AsyncFunction<TParams, TData>,
  options?: AsyncStateHookOptions
) => {
  const [asyncState, callService] = useAsyncState<TParams, TData>(
    service,
    options
  );

  return [asyncState, callService] as const;
};
